
import {Component, Vue, Watch} from 'vue-property-decorator';
import stores from '@/stores';
import vPagination from '@/components/VuePlainPagination.vue';
import Skeleton from '@/modules/Skeleton.vue';
import NevronEmpty from '@/components/NevronEmpty.vue';
import NevronSearch from '@/components/NevronSearch.vue';
import NevronSearchNoResults from '@/components/NevronSearchNoResults.vue';
import CreateDevice from './Create.vue';
import PerPageDropdown from '@/components/PerPageDropdown.vue';
import ListNevronHeader from '@/components/ListNevronComponents/ListNevronHeader.vue';
import EmptyNevronHeader from '@/components/ListNevronComponents/EmptyNevronHeader.vue';

@Component({
  components: {
    vPagination,
    ListNevronHeader,
    EmptyNevronHeader,
    Skeleton,
    NevronEmpty,
    NevronSearch,
    NevronSearchNoResults,
    CreateDevice,
    PerPageDropdown,
  },
})

export default class DevicesList extends Vue {
  response: any = null;
  items = stores.Devices;

  perpage = 20;
  firstLoad = true;

  search: any = {
    query: '',
    current: '',
  };

  indexList: number[] = [];
  allChecked: boolean = false;

  /*
   * Watch for pagination
   */
  @Watch('response.currentPage')
  ChangedPage() {
    if (this.firstLoad) {
      this.firstLoad = false;
      return;
    }
    this.search.query = this.search.current;
    this.fetchData(this.response.currentPage, this.search.current);
  }

  perPageChange() {
    this.fetchData(1, this.search.query);
  }

  /**
   * Called when changes need to re-render
   */
  mounted() {
    // set search query from URL
    if (this.$route.query.search) {
      this.search.query = this.$route.query.search;
      this.search.current = this.$route.query.search;
    }

    // set page from URL
    let index = 1;
    if (this.$route.query.page) {
      index = Number(this.$route.query.page);
    }
    if (this.$route.query.perpage) {
      this.perpage = Number(this.$route.query.perpage);
    }

    // load data
    this.fetchData(index, this.search.current);
  }

  // Refersh page method
  refresh() {
    this.fetchData(1, null);
  }

  /**
   * Fetches data on the specified page and with the specified query
   */
  fetchData(index: number | null, search: string | null) {
    return stores.Devices.fetchData(index, search, this.perpage)
      .then((response) => {
        this.response = response;
        this.items = this.response.data;
        this.search.current = this.search.query;
        this.updateCheck();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  openItem(itemId: number | string) {
    this.$router.push({
      name: 'devices.show',
      params:
        {id: String(itemId)},
      query: {
        lastpage: String(this.response.currentPage),
        perpage: String(this.perpage),
      },
    });
  }

  /* removes or appends all items ids on current page to indexList */
  checkAll() {
    if (!this.allChecked) {
      this.indexList = Array.from(new Set([...this.indexList, ...this.itemIds]));
      this.allChecked = true;
    } else {
      this.indexList = this.indexList.filter((id) => !this.itemIds.includes(id));
      this.allChecked = false;
    }
  }

  /* when item is checked */
  updateCheck() {
    if (this.itemIds.every((id: number) => this.indexList.includes(id))) {
      this.allChecked = true;
    } else {
      this.allChecked = false;
    }
  }

  get itemIds(): number[] {
    // @ts-ignore
    return this.items.map((item: any) => item.id);
  }

  unknownClicked() {
    return null;
  }

}
